import { CreativeAddNetworkDataTypes } from "@/model/creative"
import {
  Button,
  InfoPack1,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  Typography,
} from "@kwaleeltd/react-ui"

export const AdNetworkInfo = ({
  last_published,
  data,
}: CreativeAddNetworkDataTypes) => {
  return last_published ? (
    <div className="flex items-center gap-4">
      <Typography variant="caption">Published</Typography>
      <div className="flex justify-center items-center h-[30px] rounded-[20px] bg-neutral-150 p-4">
        <Typography variant="caption">
          {new Date(last_published).toLocaleDateString("en-US", {
            month: "short",
            day: "2-digit",
            year: "numeric",
          })}
        </Typography>
        {data?.length && (
          <Popover>
            <Button iconButton variant="text" component={PopoverTrigger}>
              <InfoPack1 />
            </Button>
            <PopoverContent
              className="z-[1000000] !w-auto bg-midnight-green-200"
              align="end"
            >
              <Typography variant="caption-medium" className="mb-2">
                History
              </Typography>
              {data.map((adData, index) => (
                <div
                  key={adData.unique_id}
                  className="flex gap-2 items-center mb-2"
                >
                  <span className="rounded-full size-4 text-[10px] flex justify-center items-center border border-solid border-midnight-green-400">
                    {index + 1}
                  </span>
                  {adData.pushed_to ? (
                    <Typography variant="caption-small">
                      {`${JSON.stringify(adData.request)} - ${new Date(
                        adData.datetime,
                      ).toLocaleDateString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                      })}`}
                    </Typography>
                  ) : (
                    <TooltipProvider delayDuration={100}>
                      <Tooltip>
                        <Button
                          className="p-0 justify-start text-error-400"
                          variant="text"
                          component={TooltipTrigger}
                        >
                          <div className="flex items-center gap-1">
                            <Typography variant="caption-small">
                              Error
                            </Typography>
                            <Typography variant="caption-small">
                              {new Date(adData.datetime).toLocaleDateString(
                                "en-US",
                                {
                                  month: "short",
                                  day: "2-digit",
                                  year: "numeric",
                                },
                              )}
                            </Typography>
                          </div>
                        </Button>
                        <TooltipContent className="z-[10000000]">
                          <Typography
                            variant="caption-small"
                            className="break-words max-w-[200px]"
                          >
                            {JSON.stringify(adData.response, null, 2)}
                          </Typography>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  )}
                </div>
              ))}
            </PopoverContent>
          </Popover>
        )}
      </div>
    </div>
  ) : (
    <div className="h-8 flex items-center justify-center">
      <Typography variant="caption">Not Published</Typography>
      {data?.length && (
        <Popover>
          <Button iconButton variant="text" component={PopoverTrigger}>
            <InfoPack1 />
          </Button>
          <PopoverContent className="z-[1000000] !w-auto bg-midnight-green-200 max-w-[300px]">
            <Typography variant="caption-medium" className="mb-2">
              History
            </Typography>
            {data.map((adData, index) => (
              <div
                key={adData.unique_id}
                className="flex gap-2 items-center mb-1"
              >
                <span className="rounded-full size-4 text-[10px] flex justify-center items-center border border-solid border-midnight-green-400">
                  {index + 1}
                </span>
                <TooltipProvider delayDuration={100}>
                  <Tooltip>
                    <Button
                      className="p-0 justify-start text-error-400"
                      variant="text"
                      component={TooltipTrigger}
                    >
                      <div className="flex items-center gap-1">
                        <Typography variant="caption-small">Error</Typography>
                        <Typography variant="caption-small">
                          {new Date(adData.datetime).toLocaleDateString(
                            "en-US",
                            {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                            },
                          )}
                        </Typography>
                      </div>
                    </Button>
                    <TooltipContent className="z-[10000000]">
                      <Typography
                        variant="caption-small"
                        className="break-words max-w-[200px]"
                      >
                        {JSON.stringify(adData.response, null, 2)}
                      </Typography>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
            ))}
          </PopoverContent>
        </Popover>
      )}
    </div>
  )
}

export default AdNetworkInfo
